import { render, staticRenderFns } from "./LayoutOneMobile.vue?vue&type=template&id=851d81ca"
import script from "./LayoutOneMobile.vue?vue&type=script&lang=js"
export * from "./LayoutOneMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports